import { makeid } from 'utils/helpers/makeid';

import { RunbookInstruction } from './runbook-instruction';

import type { IClinicalRunbook } from '../use-clinical-runbook';
import type { ICriticalReadingData } from '../types';
import type { TFormItem } from '../../types';

// System-determined results are pre-filled by use-logic; 'unable-to-recheck' is MA-selected.
// The runbook question only appears when the recheck is At-Risk or Unable to Recheck.
export const buildStep4Config = (
  runbook: IClinicalRunbook,
  recheck: ICriticalReadingData['recheck'],
): TFormItem[] => {
  const items: TFormItem[] = [
    {
      key: makeid(10),
      name: 'recheck',
      type: 'radio',
      title: <p>#4 Reading Recheck</p>,
      description:
        'The system classifies the transmitted repeat reading. Select "Unable to Recheck" only if a repeat reading could not be obtained.',
      required: true,
      options: [
        {
          key: makeid(10),
          label: 'Back to Normal (system-determined)',
          value: 'normal',
        },
        {
          key: makeid(10),
          label: 'At-Risk (system-determined)',
          value: 'at-risk',
        },
        {
          key: makeid(10),
          label: 'Still Critical (system-determined)',
          value: 'still-critical',
        },
        {
          key: makeid(10),
          label: 'Unable to Recheck',
          value: 'unable-to-recheck',
        },
      ],
    },
  ];

  if (recheck === 'at-risk' || recheck === 'unable-to-recheck') {
    items.push(
      {
        key: makeid(10),
        name: 'atRiskRunbookInfo',
        type: 'info',
        html: <RunbookInstruction runbook={runbook} />,
      },
      {
        key: makeid(10),
        name: 'atRiskRunbook',
        type: 'radio',
        title: <p>Is there a runbook entry for this scenario?</p>,
        required: true,
        options: [
          { key: makeid(10), label: 'Yes', value: 'has-entry' },
          { key: makeid(10), label: 'No', value: 'no-entry' },
        ],
      },
    );
  }

  return items;
};
